import platform from '@play-co/gcinstant';
import StateObserver from 'src/StateObserver';
import { isPlatformGuest } from './utils';
import { getLocale } from '../replicant/getters/user';

export function updatePrivateProfile() {
  const { user } = StateObserver.getState();

  // if (isPlatformGuest(platform) && getLocale(user) === 'ja') {
  //  platform.playerName = 'ご主人たま';
  // }

  if (
    !user.profile ||
    user.profile.name !== platform.playerName ||
    user.profile.photo !== platform.playerPhoto
  ) {
    void StateObserver.invoke.updatePrivateProfile({
      name: platform.playerName,
      photo: platform.playerPhoto,
    });
  }
}
